import * as d3 from "d3";
import * as React from "react";
import { AutoScaleSvg } from "../AutoScaleSvg";
import "./Pie.css";
import { PieData } from "@store";

export interface PieProps {
    data: PieData[];
    circleWidth?: number;
    className?: string;
}

export function Pie(props: PieProps) {
    const angleScale = d3
        .scaleLinear()
        .domain([0, d3.sum(props.data, s => s.value)])
        .range([0, (360 * Math.PI) / 180]);

    const arc = d3
        .arc()
        .innerRadius(50 - (props.circleWidth || 10))
        .outerRadius(50);

    return (
        <AutoScaleSvg viewportHeight={100} viewportWidth={100} className={props.className}>
            {props.data.map((item, index, arr) => {
                const sumBefore = d3.sum(arr.slice(0, index), d => d.value);
                const thisArc = arc
                    .startAngle(angleScale(sumBefore))
                    .endAngle(angleScale(sumBefore + item.value) - Math.PI / 180);
                return (
                    <path key={`Arc-${index}`} transform="translate(50, 50)" d={(thisArc as any)()} fill={item.color} />
                );
            })}
        </AutoScaleSvg>
    );
}
